import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import ReactBSAlert from "react-bootstrap-sweetalert";
import api from "../../../../../../services/api";
import { ModeloSite } from "..";

interface SelecionarPaginasVendasModalProps {
  isOpen: boolean;
  onClose: () => void;
  modelosSites: ModeloSite[];
  paginasSelecionadas: ModeloSite[];
  onSelecionar: (pagina: ModeloSite) => void;
  reload?: () => Promise<void>;
}

export const SelecionarPaginasVendasModal: React.FC<
  SelecionarPaginasVendasModalProps
> = ({
  isOpen,
  onClose,
  modelosSites,
  paginasSelecionadas,
  onSelecionar,
  reload,
}) => {
  const [alert, setAlert] = useState<React.ReactNode | null>(null);
  const [savingId, setSavingId] = useState<number | null>(null);

  async function confirmarSelecao(page: ModeloSite) {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block" }}
        title="Confirmação"
        onConfirm={async () => {
          setAlert(null);
          await upsertPagina(page);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="danger"
        confirmBtnText="Sim"
        cancelBtnText="Não"
        showCancel
      >
        Deseja realmente selecionar esta página de vendas?
      </ReactBSAlert>
    );
  }

  async function upsertPagina(page: ModeloSite) {
    try {
      setSavingId(page.id);

      // POST: cria ou reativa (backend já lida com isso)
      await api.post(`/marketing/modelos-sites/empresa/pagina-vendas`, {
        modelo_site_id: page.id,
        status: true,
      });

      onSelecionar(page);

      if (reload) await reload();

      setAlert(
        <ReactBSAlert
          success
          style={{ display: "block" }}
          title="Sucesso!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
        >
          Página de vendas adicionada/reativada com êxito!
        </ReactBSAlert>
      );

      // 👇 opcional: fechar o modal após adicionar
      // onClose();
    } catch (err: any) {
      console.error(err);
      const msg =
        err?.response?.data?.message ||
        "Não foi possível adicionar a página de vendas.";
      setAlert(
        <ReactBSAlert
          danger
          style={{ display: "block", marginTop: "-100px" }}
          title="Erro"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
        >
          {msg}
        </ReactBSAlert>
      );
    } finally {
      setSavingId(null);
    }
  }

  // Evita mostrar opções já selecionadas nesta sessão
  const opcoes = modelosSites.filter(
    (site) =>
      site.tipo_modelo === "pagina_vendas" &&
      !paginasSelecionadas.some((sel) => sel.id === site.id)
  );

  console.log(opcoes);

  return (
    <>
      {alert}
      <Modal isOpen={isOpen} toggle={onClose} style={{ maxWidth: "90%" }}>
        <ModalHeader toggle={onClose}>
          Selecione as páginas de vendas
        </ModalHeader>
        <ModalBody>
          {opcoes.length === 0 ? (
            <p style={{ margin: 0 }}>
              Nenhum modelo disponível no momento. Tente novamente em instantes.
            </p>
          ) : (
            <Row>
              {opcoes.map((page, index) => (
                <Col xs={12} sm={6} md={4} key={page.id}>
                  <Card>
                    <CardImg
                      top
                      src={`${page.link}preview`}
                      alt={`Modelo ${index + 1}`}
                    />
                    <CardBody>
                      <CardTitle>Modelo {index + 1}</CardTitle>
                      <Button
                        size="sm"
                        color="primary"
                        onClick={() => confirmarSelecao(page)}
                        disabled={savingId === page.id}
                      >
                        {savingId === page.id ? "Salvando..." : "Selecionar"}
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={onClose}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
